import React from 'react'
import { Form, Tooltip } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { BasSwitch, IconFont } from '@/components'

const TemplateIncrementalToggle: React.FC = () => (
  <Wrapper>
    <Form.Item
      name="isLatest"
      label={
        <div className="custom-label">
          <span>{t('执行增量')}</span>
        </div>
      }
      valuePropName="checked"
    >
      <BasSwitch style={{ marginLeft: 8 }} />
    </Form.Item>
    <Tooltip title={t('启用后则对全选用例的模版周期执行时执行新添加到模版中的用例')}>
      <IconFont type="icon-icon_help" className="help-icon" />
    </Tooltip>
  </Wrapper>
)

export default TemplateIncrementalToggle

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-left: 45px;

  .custom-label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .help-icon {
    color: #999;
    font-size: 16px;
    cursor: 'pointer';
    margin-left: 16px;
    margin-top: -24px;
  }
`
